// extracted by mini-css-extract-plugin
export var learnMore = "learnMore-module--learn-more--5db0a";
export var learnMore__text = "learnMore-module--learn-more__text--989f5";
export var learnMore__wrapper = "learnMore-module--learn-more__wrapper--6d2ba";